import { render, staticRenderFns } from "./login-message.vue?vue&type=template&id=23077d10&scoped=true&"
import script from "./login-message.vue?vue&type=script&lang=js&"
export * from "./login-message.vue?vue&type=script&lang=js&"
import style0 from "./login-message.vue?vue&type=style&index=0&id=23077d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23077d10",
  null
  
)

export default component.exports